import {apiFetchChartData, ChartResults, ChartOptions} from "../../../../actions/queryBuilderApi";
import {useState, useEffect} from "react";

export const useChartDataFetcher = (chartOptions: ChartOptions | undefined) => {

    const [chartData, setChartData] = useState<ChartResults>({ labels: [], values: [] })

    useEffect(() => {

        const { values = [], xFields = [], yFields = [] } = chartOptions || {}
        const hasValidFields = values.length > 0 && (xFields.length > 0 || yFields.length > 0)

        if (!chartOptions?.queryId || !hasValidFields) {
            setChartData({ labels: [], values: [] })
            return
        }

        let isCancelled = false

        const timer = setTimeout(async () => {
            try {
                const data = await apiFetchChartData(chartOptions)
                if (!isCancelled) {
                    setChartData(data)
                }
            } catch (error) {
                console.error("Failed to fetch chart data:", error)
                if (!isCancelled) {
                    setChartData({ labels: [], values: [] })
                }
            }
        }, 300)

        return () => {
            isCancelled = true
            clearTimeout(timer)
        }
    }, [chartOptions])

    return chartData
}